import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  getLeaderBoard,
  getLeaderboardData,
  getLeaderboardError,
  getLeaderboardStatus,
} from "../../../redux/slice/leaderboardSlice";
import AlertBox from "../../common/AlertBox";
import Loading from "../../common/Loading";
import UpperSection from "../common/UpperSection";
import ResultList from "./ResultList";
import moment from "moment";
import { fetchTopics, getTopics } from "../../../redux/slice/topicSlice";

const AdminResult = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const data = useSelector(getLeaderboardData);
  const status = useSelector(getLeaderboardStatus);
  const error = useSelector(getLeaderboardError);
  const topics = useSelector(getTopics);

  useEffect(() => {
    if (data.length === 0) {
      dispatch(getLeaderBoard());
    }
    if (!topics) {
      dispatch(fetchTopics());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [topics]);

  const [topic, setTopic] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const onChange = (dates) => {
    const [start, end] = dates;

    // console.log(start);
    // console.log(end);

    setStartDate(start);
    setEndDate(end);
  };
  const filteredResult = data?.filter((result) => {
    return result?.userDetails?.name.toLowerCase().includes(searchQuery);
  });

  const filteredData = filteredResult?.filter((entry) =>
    topic
      ? entry.examDetails?.topicName === topic ||
        entry.dynamicExamDetails?.topicName === topic
      : entry
  );

  const dateFilteredData = filteredData?.filter((entry) => {
    if (startDate && endDate) {
      const selectedTo = moment(endDate).add(1, "d");
      const selectedFrom = moment(startDate);
      const updatedAt = moment(entry.updatedAt);
      return (
        updatedAt.isSameOrBefore(selectedTo) &&
        updatedAt.isSameOrAfter(selectedFrom)
      );
    } else {
      return entry;
    }
  });

  return (
    <section className="flex flex-col gap-12 w-full">
      {status === "loading" ? <Loading /> : null}
      {status === "failed" ? <AlertBox type="failed" message={error} /> : null}
      {/* Upper Section */}
      <UpperSection
        title="Result"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <section className="bg-primary flex flex-col gap-4 w-full sm:p-7 p-2 rounded-[4px] border border-adminMainBorder">
        <div className="flex sm:flex-row flex-col w-full justify-between items-center gap-3">
          <span className="text-textPrimary text-[18px] font-semibold">
            Results
          </span>
          <div className="flex sm:flex-row flex-col sm:gap-6 gap-3 items-center justify-center">
            <DatePicker
              selected={startDate}
              onChange={onChange}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              maxDate={new Date()}
              isClearable={true}
              className="h-[32px] px-4 border border-gray-500 rounded-[4px] text-sm placeholder:text-textSecondary"
              placeholderText="Select date range"
            />
            <select
              name="topic"
              id="topic"
              value={topic}
              onChange={(e) => setTopic(e.target.value)}
              className="h-[32px] px-4 text-sm border rounded-[4px] border-gray-500 focus:outline-none text-textSecondary w-full"
            >
              <option value="">All topics</option>
              {topics?.map((topicItem) => (
                <option key={topicItem._id} value={topicItem.topicName}>
                  {topicItem.topicName}
                </option>
              ))}
            </select>
          </div>
        </div>
        <ResultList data={dateFilteredData} />
      </section>
    </section>
  );
};

export default AdminResult;
